import "./App.css";
import "./AppMobile.css";

import React from "react";
import { getFileServer, hideProcess, setLocaleApp, showProcess, UserSession } from "./utils/util";
import { OverlayPanel } from "primereact/overlaypanel";
import logo from "./img/logo.svg";
import userSVG from "./img/user.svg";
import cartSVG from "./img/cart.svg";

import { Dialog } from "primereact/dialog";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import shoppingCartService from "./services/shoppingCartService";
import { Badge } from "primereact/badge";
import "./Interceptors";
import { AutoComplete } from "primereact/autocomplete";
import productService from "./services/productService";
import Terms from "./pages/terms";
import accountService from "./services/accountService";


export default class App extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            search: "",
            countLinesCart: 0,
            products: [],
            fileServer: getFileServer(),
        };
    }

    async componentDidMount() {
        setLocaleApp();

        try {
            this.refreshCart();
        } catch (e) {
            console.dir(e);
        }
    }

    refreshCart = async () => {
        if (UserSession !== null && UserSession !== undefined) {
            const response = await shoppingCartService.getCountLines();

            if (response.status === 200) {
                this.setState({ countLinesCart: response.data });
            }
        } else {
            var shoppingcart = JSON.parse(localStorage.getItem("shoppingCart"));

            if (shoppingcart !== null && shoppingcart !== undefined) {
                this.setState({ countLinesCart: shoppingcart.lines.length });
            }
        }
    };

    logout = () => {
        if (window.confirm("Deseja finalizar sua sessão?")) {
            localStorage.clear();
            window.location.href = "/";
        }
    };

    search = async (event) => {
        var products = [];

        const response = await productService.getByStatusAndTypeAndLikeName(
            "ACTIVE",
            "VIRTUAL",
            event.query.toLowerCase()
        );

        if (response.status === 200) {
            products = response.data.filter((p) => !p.child);
        }

        let filteredSugestions;

        if (!event.query.trim().length) {
            filteredSugestions = [];
        } else {
            filteredSugestions = products.filter((p) => {
                return p.name.toLowerCase().includes(event.query.toLowerCase());
            });
        }

        filteredSugestions = [{ query: event.query }, ...filteredSugestions];

        this.setState({ filteredSugestions: filteredSugestions });
    };

    listPrices(product) {
        if (product.childProducts !== undefined) {
            return product.childProducts
                .sort((a, b) => a.amount - b.amount)
                .map((p) => (
                    <div
                        style={{
                            border: "1px solid #0F1194",
                            color: "#0F1194",
                            padding: "2px 8px",
                            borderRadius: "13px",
                            backgroundColor: "#C4C5E5",
                        }}
                    >
                        R${p.amount}
                    </div>
                ));
        } else {
            return (
                <div
                    style={{
                        border: "1px solid #0F1194",
                        color: "#0F1194",
                        padding: "2px 8px",
                        borderRadius: "13px",
                        backgroundColor: "#C4C5E5",
                    }}
                >
                    R${product.amount}
                </div>
            );
        }
    }

    sugestionsTemplate = (e) => {
        if (e.id !== undefined) {
            return (
                <table style={{ borderBottom: "1px solid gray", width: "100%" }}>
                    <tr>
                        <td rowSpan={2} style={{ paddingRight: "10px", width: "100px" }}>
                            <img
                                src={`${this.state.fileServer}/cards/${e.id}.png`}
                                alt="Gamers Fans"
                                style={{ width: "100px", height: "60px" }}
                            />
                        </td>
                        <td style={{ verticalAlign: "bottom" }}>{e.displayName}</td>
                    </tr>
                    <tr>
                        <td style={{ verticalAlign: "top" }}>
                            <div style={{ display: "flex", gap: "20px" }}>{this.listPrices(e)}</div>
                        </td>
                    </tr>
                </table>
            );
        } else {
            return (
                <div
                    style={{
                        padding: "10px 4px",
                        borderBottom: "1px solid gray",
                        width: "100%",
                    }}
                >
                    Buscar {e.query}... <span className="pi pi-search" />
                </div>
            );
        }
    };

    selectSugestion = (e) => {
        if (e.value.id !== undefined) {
            window.location.href = "/product/" + e.value.id;
        } else {
            window.location.href = "/store?query=" + e.value.query;
        }
    };

    changeSugestion = (e) => {
        if (typeof e.value !== "object") {
            this.setState({ sugestions: e.value });
        }
    };

    isNumero(valor) {
        return typeof valor === 'number' && !Number.isNaN(valor);
    }

    getBalance = () => {
        try {
            if (!this.showBalance()) {
                return "R$ ****";
            }

            var balance = parseFloat(localStorage.getItem("balance"));

            if (!this.isNumero(balance)) {
                return "R$ 0,00";
            }

            return (
                "R$ " +
                balance.toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })
            );
        } catch (e) {
            return "R$ 0,00";
        }
    };

    checkBalance = async () => {

         try {
            await showProcess();

            if (UserSession !== null && UserSession !== undefined) {
                const response = await accountService.getBalance();

                if (response.status === 200) {
                    await localStorage.setItem("balance", JSON.stringify(response.data));

                    this.setState({ showBalance: true });
                }
            } 

        } catch (err) {
            if (err.response) {
                console.log("status", err.response.status);
                console.log("headers", err.response.headers);
                console.log("data", err.response.data); // <- aqui normalmente vem a dica do que faltou
            } else {
                console.log("message", err.message);
            }
        }

        hideProcess();
    }

    showBalance = () => {
        return localStorage.getItem("showBalance") === "true";
    };

    getFirstName = () => {
        if (UserSession && UserSession.name) {
            return UserSession.name.split(' ')[0];
        }
        return "CONTA";
    };

    render() {
        return (
            <div className="app">
                {/* HEADER PRINCIPAL COM NAVEGAÇÃO */}
                <div className="app-header-wrapper">
                    {/* COLUNA 1: Logo */}
                    <div className="header-logo">
                        <img
                            src={logo}
                            onClick={() => (window.location.href = "/")}
                            alt="Logo"
                        />
                    </div>

                    {/* COLUNA 2, LINHA 1: Busca, Links, Ações */}
                    <div className="app-header">
                        {/* Barra de busca */}
                        <div className="header-section header-search">
                            <div className="search-container">
                                <AutoComplete
                                    className="app-search"
                                    placeholder="Procure aqui seu cartão-presente ou marca"
                                    value={this.state.sugestions}
                                    suggestions={this.state.filteredSugestions}
                                    completeMethod={this.search}
                                    panelClassName="app-search-panel"
                                    itemTemplate={(e) => this.sugestionsTemplate(e)}
                                    onChange={(e) => this.changeSugestion(e)}
                                    onSelect={(e) => this.selectSugestion(e)}
                                />
                                <span className="pi pi-search" style={{color: "var(--unnamed-color-411172)"}} />
                            </div>
                        </div>

                        {/* Links de suporte - Desktop only */}
                        
                        <div className="header-section header-links">
                             {UserSession !== null && (
                                <a href="/orders" className="support-link">STATUS DE COMPRA</a>
                            )}
                            {UserSession === null && (
                                <a href="/how-it-works" className="support-link">
                                    COMO FUNCIONA
                                </a>
                            )}
                            
                            <span className="link-divider">|</span>
                            <a href="https://www.omelhorpresentepara.com.br/ContactUs" target="_blank"  className="support-link">SUPORTE</a>
                            <span className="link-divider">|</span>
                            <a href="https://www.omelhorpresentepara.com.br" target="_blank"  className="support-link">RESGATAR CARTÃO-PRESENTE</a>
                        </div>
                        

                        {/* Ações de usuário */}
                        <div className="header-section header-actions">
                            {UserSession === null && (
                                <>
                                    <button
                                        className="action-btn login-btn"
                                        onClick={() => (window.location.href = "/login")}
                                    >
                                        <img src={userSVG} alt="User" style={{height: "25px"}} />
                                        <span className="btn-label app-hide-in-mobile" style={{color: "var(--unnamed-color-411172)", fontSize: "8px"}}>LOGIN</span>
                                    </button>

                                    <button
                                        className="action-btn cart-btn"
                                        onClick={() => (window.location.href = "/cart")}
                                    >
                                        <img src={cartSVG} alt="Cart" style={{height: "25px"}} />
                                        {this.state.countLinesCart > 0 && (
                                            <Badge
                                                value={this.state.countLinesCart}
                                                className="cart-badge app-hide-in-mobile"
                                                style={{backgroundColor: "var(--unnamed-color-411172)"}}
                                            />
                                        )}
                                    </button>
                                </>
                            )}

                            {UserSession !== null && (
                                <>
                                    <button
                                        className="action-btn user-btn"
                                        onClick={(e) => this.menuUser.show(e)}
                                    >
                                        <div style={{width: "25px", height: "25px", backgroundColor: "var(--unnamed-color-411172)", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", color: "#ffffff", fontWeight: "bold"}}>{this.getFirstName().charAt(0).toUpperCase()}</div>
                                        {window.innerWidth > 480 && <span className="btn-label app-hide-in-mobile">Olá, {this.getFirstName().toUpperCase()}</span>}
                                    </button>

                                    <button
                                        className="action-btn cart-btn"
                                        onClick={() => (window.location.href = "/cart")}
                                    >
                                        <img src={cartSVG} alt="Cart" style={{height: "25px"}} />
                                        {this.state.countLinesCart > 0 && (
                                            <Badge
                                                value={this.state.countLinesCart}
                                                className="cart-badge app-hide-in-mobile"
                                                style={{backgroundColor: "var(--unnamed-color-411172)"}}
                                            />
                                        )}
                                    </button>

                                    <OverlayPanel ref={(ref) => (this.menuUser = ref)} style={{padding: "0px"}}>
                                        Saldo:
                                        <br/>
                                        <div className="balance-section">
                                            <span
                                                className={`pi ${this.showBalance() ? "pi-eye-slash" : "pi-eye"}`}
                                                onClick={() => {
                                                    localStorage.setItem(
                                                        "showBalance",
                                                        localStorage.getItem("showBalance") !== "true"
                                                    );
                                                    this.setState({});
                                                }}
                                            />
                                            <span className="balance-text">{this.getBalance()}</span>
                                            <span
                                                className="pi pi-refresh"
                                                onClick={() => this.checkBalance()}
                                            />
                                        </div>
                                        <hr />
                                        <a onClick={() => window.location.href = "/profile"} style={{cursor: "pointer"}}>Perfil</a>
                                        <hr />
                                        <a onClick={() => window.location.href = "/orders"} style={{cursor: "pointer"}}>Meus Pedidos</a>
                                        <hr />
                                        <a onClick={() => this.logout()} style={{cursor: "pointer"}}>Sair</a>
                                    </OverlayPanel>
                                </>
                            )}

                            {/* Menu hambúrguer mobile */}
                            
                            <button
                                className="hamburger-btn"
                                style={{display: "none"}}
                                onClick={(e) => this.menuMobile.toggle(e)}
                            >
                                <span className="pi pi-bars" />
                            </button>


                        </div>
                    </div>

                    {/* COLUNA 2, LINHA 2: MENU DE NAVEGAÇÃO */}
                    <nav className="header-nav">
                        {/* Desktop Menu */}
                        
                        <div className="nav-container">
                            <button
                                className="nav-btn"
                                onClick={(e) => this.ovCategory.toggle(e)}
                            >
                                CATEGORIAS <i className="pi pi-chevron-down"></i>
                            </button>

                            <button className="nav-btn"onClick={() => (window.location.href = "/category/mastercard")}>
                                CARTÃO MASTERCARD<sup>®</sup>
                            </button>

                            <button
                                className="nav-btn"
                                onClick={() =>
                                    (window.location.href = "/brands")
                                }
                            >
                                MARCAS
                            </button>

                            <button
                                className="nav-btn"
                                onClick={() => {
                                    window.location.href = "/companies";
                                }}
                            >
                                PARA EMPRESAS
                            </button>
                        </div>
                    
                        {/* Mobile Menu */ }
                        <OverlayPanel
                            ref={(ref) => (this.menuMobile = ref)}
                            className="app-overlay-mobile-category"
                            style={{
                                left: "50%",
                                transform: "translateX(-50%)",
                            }}
                        >
                            <div className="mobile-menu">
                                <button
                                    className="mobile-menu-btn"
                                    onClick={(e) => {
                                        this.ovCategory.toggle(e);
                                        this.menuMobile.hide();
                                    }}
                                >
                                    Categorias
                                </button>

                                <button
                                    className="mobile-menu-btn"
                                    onClick={() => {
                                        window.location.href =
                                            "/store?supplier=multimarcas";
                                        this.menuMobile.hide();
                                    }}
                                >
                                    Cartão-Presente Multimarcas
                                </button>

                                <button
                                    className="mobile-menu-btn"
                                    onClick={() => {
                                        window.location.href = "/howtouse";
                                        this.menuMobile.hide();
                                    }}
                                >
                                    Como Utilizar
                                </button>

                                <button
                                    className="mobile-menu-btn"
                                    onClick={() => {
                                        window.location.href =
                                            "https://www.omelhorpresentepara.com.br";
                                        this.menuMobile.hide();
                                    }}
                                >
                                    Resgatar seus créditos
                                </button>

                                <button
                                    className="mobile-menu-btn"
                                    onClick={() => {
                                        this.menuMobile.hide();
                                        window.location.href = "/bhnincentivos";
                                    }}
                                >
                                    Para Empresas
                                </button>

                                <button
                                    className="mobile-menu-btn"
                                    onClick={() => {
                                        window.location.href =
                                            "https://www.omelhorpresentepara.com.br/ContactUs";
                                        this.menuMobile.hide();
                                    }}
                                >
                                    <span className="pi pi-question-circle" />
                                    Central de ajuda
                                </button>
                            </div>
                        </OverlayPanel>
                        
                    </nav>
                </div>

                {/* CONTEÚDO PRINCIPAL */}
                <div className="app-content-children">
                    {React.cloneElement(this.props.children, {
                        search: this.state.search,
                        refreshCart: () => this.refreshCart(),
                    })}
                </div>

                <OverlayPanel
                    ref={(ref) => (this.ovCategory = ref)}
                    className="app-overlay-category"
                >
                   <div className="app-categories">
                        <button
                            onClick={() => (window.location.href = "/category/games")}
                        >
                            <label>Games</label>
                        </button>

                        <button
                            onClick={() => (window.location.href = "/category/gastronomia")}
                        >
                            <label>Gastronomia</label>
                        </button>

                        <button
                            onClick={() => (window.location.href = "/category/saúde") }
                        >
                            <label>Saúde</label>
                        </button>

                        <button
                            onClick={() => (window.location.href = "/category/infantil")}
                        >
                            <label>Infantil</label>
                        </button>

                        <button
                            onClick={() => (window.location.href = "/category/entretenimento")}
                        >
                            <label>Entretenimento</label>
                        </button>

                        <button
                            onClick={() => (window.location.href = "/category/moda")}
                        >
                            <label>Moda</label>
                        </button>                        

                        <button
                            onClick={() => (window.location.href = "/category/transporte")}
                        >
                            <label>Transporte</label>
                        </button>

                        <button
                            onClick={() => (window.location.href = "/category/alimentação")}
                        >
                            <label>Alimentação</label>
                        </button>

                        <button
                            onClick={() => (window.location.href = "/category/compras online")}
                        >
                            <label>Compras Online</label>
                        </button>

                        <button
                            onClick={() => (window.location.href = "/category/delivery")}
                        >
                            <label>Delivery</label>
                        </button>
                        
                    </div>
                </OverlayPanel>

                <div className="app-about">
                    <table>
                        <tbody style={{fontWeight: "600"}}>
                            <tr>
                                <td style={{borderBottom: "1px solid #ccc", fontSize: "14px"}}>SOBRE</td>
                                <td style={{borderBottom: "1px solid #ccc", fontSize: "14px"}}>SUPORTE</td>
                                <td style={{borderBottom: "1px solid #ccc", fontSize: "14px"}}>LEGAL</td>
                                <td rowspan="4" style={{ width: "150px" }} className="hide-in-618">
                                    <img
                                        src={logo}
                                        onClick={() => (window.location.href = "/")}
                                        alt="Logo"
                                        style={{border: "2px solid #fff", borderRadius: "50%"}}
                                    />
                                    
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <a
                                        href="/"
                                        style={{ color: "#ffffff", textDecoration: "none", fontSize: "14px" }}
                                    >
                                        Home
                                    </a>
                                </td>
                                <td>
                                    <a
                                        href="https://api.whatsapp.com/send/?phone=5511942505855&text=Ol%C3%A1%2C+gostaria+de++saber+mais+sobre+a+BHN&type=phone_number&app_absent=0"
                                        style={{ color: "#ffffff", textDecoration: "none", fontSize: "14px" }}
                                    >
                                        Contato
                                    </a>
                                </td>
                                <td>
                                    <a
                                        onClick={() => this.setState({ showTerms: true })}
                                        style={{
                                            color: "#ffffff",
                                            textDecoration: "none",
                                            cursor: "pointer",
                                            fontSize: "14px"
                                        }}
                                    >
                                        Termos de Uso
                                    </a>
                                </td>
                                
                            </tr>
                            <tr>
                                <td>
                                    <a
                                        href="/bhnincentivos"
                                        style={{ color: "#ffffff", textDecoration: "none", fontSize: "14px" }}
                                    >
                                        Compra corporativa
                                    </a>
                                </td>
                                <td>
                                    <a
                                        href="https://www.omelhorpresentepara.com.br/ContactUs"
                                        style={{ color: "#ffffff", textDecoration: "none", fontSize: "14px" }}
                                    >
                                        FAQ's
                                    </a>
                                </td>
                                <td>
                                    <a
                                        onClick={() => this.setState({ showTerms: true })}
                                        style={{
                                            color: "#ffffff",
                                            textDecoration: "none",
                                            cursor: "pointer",
                                            fontSize: "14px"
                                        }}
                                    >
                                        Política de Privacidade
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <a
                                        href="https://blackhawknetwork.com/br-pt"
                                        target="_blank"
                                        style={{ color: "#ffffff", textDecoration: "none", fontSize: "14px" }}
                                    >
                                        Sobre nós
                                    </a>
                                </td>
                                <td>
                                    {UserSession !== null && (
                                        <a
                                            href="/orders"
                                            style={{ color: "#ffffff", textDecoration: "none", fontSize: "14px" }}
                                        >
                                            Status de compra
                                        </a>
                                    )}
                                    {UserSession === null && (
                                        <a
                                            href="/how-it-works"
                                            target="_blank"
                                            style={{ color: "#ffffff", textDecoration: "none", fontSize: "14px" }}
                                        >
                                            Como Funciona
                                        </a>
                                    )}
                                    
                                </td>
                                <td>
                                    <a
                                        onClick={() => this.setState({ showTerms: true })}
                                        style={{
                                            color: "#ffffff",
                                            textDecoration: "none",
                                            cursor: "pointer",
                                            fontSize: "14px"
                                        }}
                                    >
                                        Política de Cookies
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>
                                    <a
                                        onClick={() => this.checkBalance()}
                                        style={{
                                            color: "#ffffff",
                                            textDecoration: "none",
                                            cursor: "pointer",
                                            fontSize: "14px"
                                        }}
                                    >
                                        Consultar Saldo
                                    </a>
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colSpan={4} style={{textAlign: "right", fontWeight: "500", fontSize: "20px", padding: "20px"}}>
                                    <img    
                                        src={require("./img/logo bhn-08.png")}
                                        style={{width: "100px"}}
                                    />
                                </td>
                                
                            </tr>
                            <tr>
                                <td colSpan={4} style={{textAlign: "center", fontWeight: "500", fontSize: "18px", padding: "20px"}}>
                                    2025 | Blackhawk Network Brasil LTDA. Todos os Direitos Reservados.
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    {this.state.showTerms && (
                        <Terms onHide={() => this.setState({ showTerms: false })} />
                    )}

                    
                </div>
            </div>
        );
    }
}
